import Card from "@mui/material/Card"
import CardHeader from "@mui/material/CardHeader"
const Dashboard = () => {
  return (
    <Card>
      <CardHeader title="Dashboard" titleTypographyProps={{ variant: "h6" }} />
    </Card>
  )
}
export default Dashboard